(() => {

    // Block Name
    const blockName = 'news-list';

    // Variables
    let method = 'front';
    if ( document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin') ) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined ) block = block[0].querySelector(`.block-${blockName}`);
        if ( block === false || block === null ) return;

        // Block Code Here




    };

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if ( blocks.length > 0 ) {
            blocks.forEach( (block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();
